export const registerUserName = ({ commit }, userName) => {
  commit("setUserName", userName);
};

export const turnOnSound = ({ commit }) => {
  commit("setSoundFlag", true);
};

export const startAnimBg = ({ commit }) => {
  commit("setIsAnimBg", true);
};

export const resetAnimBg = ({ commit }) => {
  commit("setIsAnimBg", false);
};

export const turnOnMovie = ({ commit }) => {
  commit("setIsMovieActive", true);
};

export const turnOffMovie = ({ commit }) => {
  commit("setIsMovieActive", false);
};

export const addBgNumber = ({ commit, state }, num = 1) => {
  commit("setBgNumber", state.bgNumber + num);
};

export const resetBgNumber = ({ commit }) => {
  commit("setBgNumber", 0);
};
